import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Drawer from '@mui/material/Drawer';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import { CardContent, Stack, Tooltip } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import { Typography } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import { fetchSenderAddress } from '../../pages/Settings/AddressSender/addressSenderSlice';
import NorowsData from '../General/NorowsData'
import WidthMaximize from './WidthMaximize'

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    boxShadow: 'none',
    border: '1px solid #E2E8F0',
    borderRadius: '12px',
    color: theme.palette.text.secondary,
    height: '100%'
}));

const PickupItemsDrawer = ({ pickupItems,visible,pickupReferenceId, pickupItemsOnClose }) => {
   
    const pickup = useSelector(state => state.pickup && state.pickup.pickupData);
    const addresssender = useSelector(state => state.addresssender);
    const [senderAddressObjectId, setSenderAddressObjectId] = useState('');
    const [drawer, setDrawer] = useState(true);
    const [drawerWidth, setDrawerWidth] = useState("80%");
    const dispatch = useDispatch();
    const ondrawerclose = () => {
        setDrawer(false)
        pickupItemsOnClose(false)
    }
        useEffect(() => {
            dispatch(fetchSenderAddress());
    }, [dispatch]);

    const columns = [
        {
            field: 'package_dimension',
            headerName: 'Package Dimension',
            headerClassName: 'super-app-theme--header',
            sortable: false,
            flex: 1.2,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Typography variant="body2" sx={{ color: '#0F172A', fontWeight: 600, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {params.row.package_dimension ? params.row.package_dimension : "-"}
                    </Typography>
                );
            }
        },
        {
            field: 'dimension_unit',
            headerName: 'Dimension Unit',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Typography variant="body2" sx={{ color: '#475569', fontWeight: 500, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {params.row.dimension_unit ? params.row.dimension_unit : "-"}
                    </Typography>
                );
            }
        },
        {
            field: 'weight',
            headerName: 'Weight',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Typography variant="body2" sx={{ color: '#0F172A', fontWeight: 700, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {params.row.weight ? params.row.weight : "-"}
                    </Typography>
                );
            }
        },
        {
            field: 'weight_unit',
            headerName: 'Weight Unit',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Typography variant="body2" sx={{ color: '#475569', fontWeight: 500, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {params.row.weight_unit ? params.row.weight_unit : "-"}
                    </Typography>
                );
            }
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            resizable: false,
            renderCell: (params) => {
                return (
                    <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', height: '100%' }}>
                        {params.row.quantity ? params.row.quantity : "-"}
                    </Typography>
                );
            }
        }
    ];
    return (
        <>

            <Drawer
                anchor="right"
                open={visible}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        ondrawerclose();
                    }
                }}
                PaperProps={{
                    sx: { width: drawerWidth, bgcolor: '#FAFAFA' },
                }}
            >

                <Box sx={{ p: 4, height: '100%', boxSizing: 'border-box', overflowY: 'auto' }}>
                    <Stack spacing={3}>
                        <Card 
                            sx={{ 
                                backgroundColor: '#FFFFFF',
                                border: '1px solid #E2E8F0',
                                borderRadius: '16px',
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)',
                                overflow: 'hidden'
                            }} 
                            className="sc--cardhead--details"
                        >
                            <CardHeader 
                                title={
                                    <Typography variant="h6" component="h1" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px', m: 0 }}>
                                        {`Pickup Details for ${pickupReferenceId}`}
                                    </Typography>
                                } 
                                action={
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <WidthMaximize
                                            defaultWidth="80%"
                                            onToggle={(newWidth) => setDrawerWidth(newWidth)}
                                        />
                                        <Tooltip title="Close Panel" placement="top">
                                            <IconButton 
                                                aria-label="close" 
                                                onClick={ondrawerclose}
                                                sx={{ 
                                                    color: '#64748B', 
                                                    borderRadius: '8px', 
                                                    border: '1px solid #E2E8F0',
                                                    p: 0.75,
                                                    transition: 'all 0.15s ease-in-out',
                                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B', borderColor: '#CBD5E1' }
                                                }}
                                            >
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                } 
                                sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                            />
                            {/* <LinearProgress /> */}
                            <Divider sx={{ borderColor: '#E2E8F0' }} />
                        </Card>
                        
                        <Card sx={{ border: '1px solid #E2E8F0', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)', backgroundColor: '#FFFFFF' }}>
                            <CardContent sx={{ p: 3 }}>
                                {pickup && pickup.loading==false && Object.keys(pickupItems).length != 0 &&
                                     <Grid container spacing={3} alignItems="stretch" sx={{ mb: 3 }}>
                                            <Grid item xs={12} md={6}>
                                                <Item variant="outlined">
                                                    <Stack spacing={1}>
                                                        <Typography variant="caption" sx={{ color: '#94A3B8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                            Origin Address
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: '#0F172A', fontWeight: 700, fontSize: '14px' }}>
                                                            {pickupItems.address.sender_name} <Box component="span" sx={{ color: '#64748B', fontWeight: 500 }}>({pickupItems.address.sender_company})</Box>
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ color: '#475569', fontWeight: 500, lineHeight: 1.6 }}>
                                                            {pickupItems.address.sender_address}, {pickupItems.address.sender_city}, {pickupItems.address.sender_state_code}, <br />
                                                            {pickupItems.address.sender_country_code} - {pickupItems.address.sender_postal_code}
                                                        </Typography>
                                                    </Stack>
                                                </Item>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <Item variant="outlined">
                                                    <Stack spacing={2} sx={{ height: '100%', justifyContent: 'center' }}>
                                                        <Box>
                                                            <Typography variant="caption" sx={{ color: '#94A3B8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', mb: 0.5 }}>
                                                                Email Contact
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 600, fontSize: '13.5px' }}>
                                                                {pickupItems.address.sender_email}
                                                            </Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography variant="caption" sx={{ color: '#94A3B8', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', mb: 0.5 }}>
                                                                Phone Number
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 600, fontSize: '13.5px' }}>
                                                                {pickupItems.address.sender_phone}
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Item>
                                            </Grid>
                                     </Grid>
                                }

                                <Box sx={{ width: '100%', mt: 1, border: '1px solid #E2E8F0', borderRadius: '12px', overflow: 'hidden' }}>
                                    <DataGrid
                                        getRowId={(row) => Math.random() + Math.random()}
                                        rows={pickupItems && pickupItems.items || []}
                                        columns={columns}
                                        autoHeight={true}
                                        disableColumnFilter={true}
                                        disableColumnMenu={true}
                                        sortingMode="server"
                                        disableRowSelectionOnClick
                                        loading={!!(pickup && pickup.loading)}
                                        sx={{
                                            border: 'none',
                                            backgroundColor: '#FFFFFF',
                                            '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC' },
                                            '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                                            '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                                            '& .MuiDataGrid-cell': { borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                                            '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                        }}
                                        slots={{
                                            noRowsOverlay: NorowsData,
                                        }}
                                    />
                                </Box>
                            </CardContent>
                        </Card>
                    </Stack>
                </Box>

            </Drawer >
        </>
    )
}

export default PickupItemsDrawer;